import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Bridges the Copilot tab and the main attendance chat composer, which live in
 * separate component subtrees of the attendance panel. The Copilot tab pushes a
 * suggested reply text and the chat composer subscribes and inserts it into its
 * message input. Mirrors the singleton-Subject pattern used by NewConversationService.
 */
@Injectable({ providedIn: 'root' })
export class CopilotComposeBridgeService {
  private readonly composeTextSubject = new Subject<string>();

  /** Emits suggested reply text that should be inserted into the chat composer. */
  readonly composeText$: Observable<string> = this.composeTextSubject.asObservable();

  /** Push a suggested reply into the main attendance chat composer. */
  pushToComposer(text: string): void {
    const value = (text ?? '').trim();
    if (!value) {
      return;
    }
    this.composeTextSubject.next(value);
  }
}
